export default __webpack_public_path__ + "static/media/motorbike-purple.781a62fb.svg";